import React from 'react';

/**
 * Get contact day and time options.
 */
export const useContactPreferenceOptions = () => {
  const dayOptions = [
    {label: 'Monday', value: 'mon', name:'contact-mon', key: 'mon'},
    {label: 'Tuesday', value: 'tue', name:'contact-tue', key: 'tue'},
    {label: 'Wednesday', value: 'wed', name:'contact-wed', key: 'wed'},
    {label: 'Thursday', value: 'thu', name:'contact-thu', key: 'thu'},
    {label: 'Friday', value: 'fri', name:'contact-fri', key: 'fri'},
  ];

  const timeOptions = [
    {label:
      [ <div className='flex flex-col'>
          <span>Morning</span>
          <span>09:00 - 12:00</span>
        </div> ],
      value: 'morning', name:'contact-morning', key: 'morning'},
    {label:
      [ <div className='flex flex-col'>
          <span>Lunch time</span>
          <span>12:00 - 14:00</span>
        </div> ],
      value: 'lunch', name:'contact-lunch', key: 'lunch'},
    {label:
      [ <div className='flex flex-col'>
          <span>Afternoon</span>
          <span>14:00 - 17:00</span>
        </div> ],
      value: 'afternoon', name:'contact-afternoon', key: 'afternoon'},
    {label:
      [ <div className='flex flex-col'>
          <span>Early evening</span>
          <span>17:00 - 18:30</span>
        </div> ],
      value: 'evening', name:'contact-evening', key: 'evening'},
  ];

  return { dayOptions, timeOptions };
};
